module.exports = __webpack_public_path__ + "static/media/selo-prata-de-inovacao.12aeec66.pdf";